(() => {
  if (window.__featureCalloutsInit) return;
  window.__featureCalloutsInit = true;

  function copyImage(from, to) {
    const srcset = from.getAttribute('srcset');
    const sizes = from.getAttribute('sizes');
    if (srcset) to.setAttribute('srcset', srcset);
    else to.removeAttribute('srcset');
    if (sizes) to.setAttribute('sizes', sizes);
    else to.removeAttribute('sizes');
    to.src = from.src;
    if (from.alt) to.alt = from.alt;
  }

  function bindWrap(wrap) {
    if (wrap.dataset.featureCalloutsReady === '1') return;
    wrap.dataset.featureCalloutsReady = '1';

    const mainImg = wrap.querySelector('.feature-callouts__media img');
    const thumbs = wrap.querySelectorAll('.feature-callouts__thumb');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      const thumbImg = thumb.querySelector('img');
      if (!thumbImg) return;
      thumb.addEventListener('click', () => {
        copyImage(thumbImg, mainImg);
        thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
      });
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.feature-callouts__media-wrap').forEach(bindWrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
